module.exports = __webpack_public_path__ + "img/docker.86726983.svg";